/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationDocumentState;

(function (ValidationDocumentState) {
  ValidationDocumentState["CANCELLED"] = "cancelled";
  ValidationDocumentState["CONFIRMED"] = "confirmed";
  ValidationDocumentState["PENDING"] = "pending";
})(ValidationDocumentState || (ValidationDocumentState = {}));